// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"980bfd4a","632":"4fc151f7","647":"061ba72a","723":"b5a2e3e5","809":"af080c5d","816":"e878ead7","972":"ee783961"}[chunkId] + ".chunk.js";
};